// extracted by mini-css-extract-plugin
module.exports = {"userDuelRivals":"UserDuelRivals_userDuelRivals__26REc","body":"UserDuelRivals_body__2WKUS","showMoreButtonWrapper":"UserDuelRivals_showMoreButtonWrapper__3MvGy"};